/* @flow */

/*::
import type { BgConfig } from "bgutils-js";
import type { RequestInit} from "node-fetch";
*/

//const { JSDOM } = require("jsdom");
import { BG } from "bgutils-js";
//const fetch = require("node-fetch");

// hardcoded API key that has been used by youtube for years
const requestKey = "O43z0dpjhgX20SCx4KAo";

export async function getPoToken(identifier /*: string */) {
  // This implementation is based off of https://github.com/LuanRT/BgUtils/blob/main/examples/node/index.ts

  // TODO: I'm not a fan of polluting the globalThis object like this, but is how the example
  // app does it. A better way might be to use vm.runInNewContext
  // $FlowFixMe: no definitions for globalThis
  const globalObj = globalThis;

  // NOTE: If you ever need this on the server, make sure to upgrade JSDOM. Otherwise,
  // the challenge won't complete successfully.
  // const dom = new JSDOM();
  // Object.assign(globalObj, {
  //   window: dom.window,
  //   document: dom.window.document
  // });

  const bgConfig /*: BgConfig */ = {
    fetch: async (
      input /*: string | URL | globalThis.Request */,
      init /*: RequestInit*/
    ) => {
      return fetch(input, init);
    },
    globalObj,
    identifier,
    requestKey
  };

  const bgChallenge = await BG.Challenge.create(bgConfig);

  if (!bgChallenge)
    throw new Error("Could not get challenge, identifier=" + identifier);

  const interpreterJavascript =
    bgChallenge.interpreterJavascript
      .privateDoNotAccessOrElseSafeScriptWrappedValue;

  if (interpreterJavascript) {
    new Function(interpreterJavascript)();
  } else throw new Error("Could not load VM, identifier=" + identifier);

  const poTokenResult = await BG.PoToken.generate({
    program: bgChallenge.program,
    globalName: bgChallenge.globalName,
    bgConfig
  });

  return poTokenResult.poToken;
}
